/** DM Sans + DM Mono, the landing design's type. Injected once per page by
 *  whichever chrome mounts first (the landing shell or the app rail). */
export function ensureLandingFonts() {
  if (typeof document === "undefined") return;
  if (document.querySelector("link[data-slv2-fonts]")) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href =
    "https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,700;1,9..40,400;1,9..40,500&family=DM+Mono:wght@300;400;500&display=swap";
  link.setAttribute("data-slv2-fonts", "");
  document.head.append(link);
}
